import ListLicenceRenew from "./ListLicenceRenew";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDrivingRenewData } from "../../../../../store/Api";
import nodeinstance from "../../../../../nodeInstance";

export default function LicenceRenew() {
  // const driving = useSelector((state) => state.DrivingTab3);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");
  const [searchWords, setSearchWords] = useState([]);

  const [driving, setData] = useState([]);

  const getRenewalData = async () => {
    try {
      const response = await nodeinstance.get("/drivingLicense?renew=1", {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.status === 200) {
        setData(response.data);
      }
    } catch (error) {
      console.log("error to be printed in the console", error);
    }
  };

  useEffect(() => {
    // dispatch(getDrivingRenewData(token));
    getRenewalData();
  }, []);

  const updateData = () => {
    dispatch(getDrivingRenewData(token));
    setData([]);
  };
  const getSearchData = async () => {
    try {
      const response = await nodeinstance.get(
        `/drivingLicense/SerachEmployee/${searchWords && searchWords[0]}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setData(response.data);
      }
    } catch (error) {
      console.log("error to be printed in the console", error);
    }
  };

  useEffect(() => {
    if (searchWords && searchWords[0]?.length > 3) {
      getSearchData();
    } else {
      console.log("............");
      getRenewalData();
    }
  }, [searchWords]);
  console.log("drivingLicData to be printed in the console", driving);
  return (
    <>
      <ListLicenceRenew
        titles={[
          "SR.NO.",
          "Employee ID",
          "Employee NAME",
          "ACTUAL PROFESSION",
          "IQAMA PROFESSION",
          "VISA PROVIDER",
          "SPONSOR",
          "CLIENT NAME",
          "IQAMA NUMBER",
          "LICENCE TYPE",
          "DRIVING LICENCE APPLY DATE",
          "DRIVING LICENCE ISSUE DATE",
          "DRIVING LICENCE EXPIRY DATE",
          "DRIVING LICENCE VALID DAYS",
          "DRIVING LICENCE ADMISSION FEES",
          "DRIVING LICENCE MEDICAL FEES",
          "DRIVING LICENCE GOVT. FEES",
          "DRIVING LICENCE INDUCEMENT FEES",
          "LICENCE STATUS",
          "checkBox",
          "",
        ]}
        list={driving?.data}
        loading={loading}
        token={token}
        updateData={updateData}
        searchWords={searchWords}
        setSearchWords={setSearchWords}
      />
    </>
  );
}
